import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import styled from "styled-components";
// import Button from "../components/Buttons";

// import { useUserContext } from "../../contexts/UserContext";
// import { useLoadContext } from "../../contexts/LoadContext";
import Button from "../components/Buttons";
import { Colors } from "../ColorConstants";
import { Text } from "../TextConstants";
import {
  userForgotPassword,
  userVerifyPassword,
} from "../services/userServices";
import { toast } from "react-toastify";
import ToastMessage from "../components/ToastMessage";
import { ForgotValidation } from "../helper";
import CustomLoader from "../components/Loader";
import { trackFBEvent } from "../analytics";
import { EVENT } from "../analytics/constants";
const loginBg = require("../assets/images/Loginbg.png");

const Otp = ({ route }) => {
  let navigate = useNavigate();
  let [searchParams] = useSearchParams();
  let data = searchParams.get("email");
  const [loading, setLoading] = useState(false);

  const [error, setError] = useState({
    otp: "",
  });

  const [otpComplete, setOTPComplete] = useState(false);

  const [otp, setOtp] = useState(new Array(4).fill(""));

  useEffect(() => {
    trackFBEvent(EVENT.CURRENT_SCREEN, { page: "OTP Page" });
  }, []);

  const handleChange = (element, index) => {
    console.log(element.value.length);
    if (element.value.length <= 1) {
      setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))]);
    }
    setOTPComplete(false);
    if (isNaN(element.value)) return false;

    console.log(otp);
    if (element.value !== "" && element.nextSibling) {
      element.nextSibling.focus();
    }
    if (element.value === "" && index > 0) {
      // Focus on the previous field
      element.previousSibling.focus();
    }
  };

  const handleResendButton = (e) => {
    e.preventDefault();
    setOtp([...otp.map((v) => "")]);
    setOTPComplete(false);
    let user = { email: data };
    const isValid = ForgotValidation(user, setError);
    if (isValid) {
      resendPin(user);
    } else {
      console.log("hgey");
    }
  };

  const resendPin = async (user) => {
    setLoading(true);
    try {
      const response = await userForgotPassword(user);
      if (response.status === 200) {
        // toast.success(response.data.message, { hideProgressBar: false });
      }
    } catch (error) {
      if (navigator.onLine) {
        toast.error(error.message, { hideProgressBar: true });
      } else {
        toast.error(
          <ToastMessage
            message="You're offline now"
            subMessage="Oops! Internet is disconnected."
          />,
          {
            hideProgressBar: true,
          }
        );
      }
    }
    setLoading(false);
  };

  const verifyOtp = async (user) => {
    setLoading(true);
    try {
      const response = await userVerifyPassword(user);
      if (response.status === 200) {
        console.log("response", response);
        // localStorage.setItem("token", response.data.token);
        // localStorage.setItem("name", response.data.name);
        // localStorage.setItem("email", response.data.name);
        // localStorage.setItem("name", response.data.name);
        toast.success(response.data.message, { hideProgressBar: true });
        navigate(`/auth/createPin?email=${data}`);
      }
    } catch (error) {
      if (navigator.onLine) {
        toast.error(error.message, { hideProgressBar: true });
      } else {
        toast.error(
          <ToastMessage
            message="You're offline now"
            subMessage="Oops! Internet is disconnected."
          />,
          {
            hideProgressBar: true,
          }
        );
      }
    }
    setLoading(false);
  };

  const handleSubmit = (e) => {
    setOTPComplete(false);
    e.preventDefault();
    let otpFinal = otp.join("");
    let user;
    user = { email: data, otp: parseInt(otpFinal) };
    if (otp.join("").length === 4) {
      verifyOtp(user);
    } else {
      setOTPComplete(true);
    }
  };

  return (
    <OtpStyled>
      <OtpModal>
        {loading ? (
          <CustomLoader />
        ) : (
          <InnerDiv>
            <Logo src={require("../assets/images/lww_logo.png")} alt="logo" />
            <HeaderRight>{Text.otpHeader}</HeaderRight>
            <SubHeaderRight>{Text.otpSubHeader}</SubHeaderRight>
            <OtpForm>
              <OtpContainer>
                {otp.map((data, index) => {
                  return (
                    <OtpInput
                      type="password"
                      name="otp"
                      maxLength="2"
                      key={index}
                      value={data}
                      onChange={(e) => handleChange(e.target, index)}
                      onFocus={(e) => e.target.select()}
                    />
                  );
                })}
              </OtpContainer>
              {otpComplete && <ErrorMessage>{Text.otpInput}</ErrorMessage>}
              <AddSpace>
                <Button
                  disabled={otp.join("").length < 4}
                  backgroundColor={
                    otp.join("").length < 4 ? Colors.aqua : Colors.aqua
                  }
                  fontColor={otp.join("").length < 4 ? "#919191" : Colors.white}
                  label="Submit"
                  variant="filled"
                  color={Colors.aqua}
                  size="large"
                  onClick={(e) => handleSubmit(e)}
                />
              </AddSpace>
            </OtpForm>

            <ResendText>
              <span>{Text.recieveCode}</span> <br />
              <span onClick={(e) => handleResendButton(e)}>
                {Text.resendCode}
              </span>
            </ResendText>
          </InnerDiv>
        )}
      </OtpModal>
    </OtpStyled>
  );
};

export default Otp;

const OtpStyled = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-image: url(${loginBg}); */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;
const OtpModal = styled.div`
  width: 32rem;
  height: 32.3rem;
  border-radius: 0.5rem;
  padding: 0 1rem;
  background: ${Colors.whiteSmoke};
  @media only screen and (max-width: 768px) {
    width: 100%;
    height: 100vh;
    border-radius: 0;
    display: flex;
    justify-content: center;
    padding: 0;
  }
`;
const InnerDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const Logo = styled.img`
  margin-top: 1rem;
  width: 22rem;
  resize: contain;
  @media only screen and (max-width: 768px) {
    margin: 2rem 0;
    width: 100%;
  }
`;
const HeaderRight = styled.div`
  font-family: "Poppins";
  font-size: 1.5rem;
  color: ${Colors.black};
  margin-top: 1.2rem;
  text-align: center;
  font-weight: 600;
`;
const SubHeaderRight = styled.div`
  font-family: "Poppins";
  font-size: 0.875rem;
  color: ${Colors.black};
  text-align: center;
  margin-top: 1.25rem;
  margin-bottom: 3rem;
  padding: 0 1rem;
`;
const OtpForm = styled.form`
  width: 20rem;
  height: 12rem;
  display: flex;
  flex-direction: column;
  @media only screen and (max-width: 768px) {
    width: 90%;
  }
`;
const OtpContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;
const OtpInput = styled.input`
  border-radius: 0.5rem;
  background: #fcfdfe;
  border: 1px solid #eee;
  width: 3rem;
  height: 2.5rem;
  font-family: "Poppins";
  font-size: 2rem;
  text-align: center;
`;
const ErrorMessage = styled.div`
  font-family: "Poppins";
  font-size: 0.75rem;
  color: ${Colors.coralRedApprox};
  position: absolute;
  margin-top: 3.5rem;
`;

const ResendText = styled.div`
  font-family: "Poppins";
  font-size: 0.875rem;
  text-align: center;

  span:first-child {
    color: ${Colors.black};
  }

  span:last-child {
    color: ${Colors.aqua};
    text-decoration: underline;
    cursor: pointer;
  }
`;

const AddSpace = styled.span`
  margin-top: 4rem;
  margin-bottom: 1rem;
`;
